<template>

    <div>
        <div class="deliveryblocks">
            <div class="leftBlock">
                <pd-deliveryblock :address="CustomsAddress" addressId="CustomsAddress" label="Customs address" :clickFn="addAddress"></pd-deliveryblock>
                <pd-deliveryblock :address="ReceivingLocation" addressId="ReceivingLocation" label="Receiving Location" :clickFn="addAddress"></pd-deliveryblock>
            </div>
            <div class="rightBlock">
                <pd-deliveryblock :address="CustomsClearance" addressId="CustomsClearance" label="Customs Clearance:" :clickFn="addAddress"></pd-deliveryblock>
                <pd-deliveryblock :address="Buyer" addressId="Buyer" label="Buyer:" :clickFn="addAddress"></pd-deliveryblock>
                <pd-deliveryblock :address="DisponentRequester" addressId="DisponentRequester" label="Disponent/Requester:" :clickFn="addAddress"></pd-deliveryblock>
            </div>


        </div>

        <div class="buttonbar">
            <pd-button label="Save" :click="saveDeliveryAddresses"></pd-button>
        </div>
    </div>

</template>


<script>
    import {mapGetters, mapState} from 'vuex';
    import Button from "../components/button.vue";
    import DeliveryBlock from "../components/deliveryinputblock.vue";
    // import {DeliveryAddressesState} from "@/store/AddressStore"


    export default {
        name: 'Currencies',
        props: {
            msg: String
        },
        components: {
            "pd-button": Button,
            "pd-deliveryblock": DeliveryBlock
        },
        computed: {
            ...mapState("addressStore", [
                "CustomsAddress",
                "CustomsClearance",
                "ReceivingLocation",
                "Buyer",
                "DisponentRequester",
            ]),
            ...mapGetters('addressStore', [
                "CustomsAddress",
                "CustomsClearance",
                "ReceivingLocation",
                "Buyer",
                "DisponentRequester",
            ])
        },
        methods: {
            addAddress(addressId) {
                this.$store.commit('addressStore/addAddressField', addressId);
            },
            saveDeliveryAddresses(){
                this.$store.commit('addressStore/persist');
            }
        },
        created() {
            this.$store.commit('addressStore/loadFromDb');
        }
    }
</script>